import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";

const SSOLoginRedirect: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const code = params.get("code");
    const sourceUrl = params.get("source_url");

    if (!sourceUrl) {
      console.error("Missing source_url");
      return;
    }

    if (!code) {
      window.location.replace(sourceUrl);
      return;
    }

    const target = new URL(sourceUrl);
    target.searchParams.set("code", code);
    window.location.replace(target.toString());
  }, []);

  return (
    <Box sx={{ position: "fixed", height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress size={60} />
    </Box>
  );
};

export default SSOLoginRedirect;
